import React, { useState, useContext, useEffect } from "react";
import Buttons from "./Buttons";
import {withRouter, Redirect} from 'react-router-dom'
import MainContext from '../../state/main/mainContext'
import ReactGA from 'react-ga';


const Modal2 = ({ history: {push} }) => {
  const [errorMsg, setErrorMsg] = useState();
  const [seeError, setSeeError] = useState(false);
  const mainContext = useContext(MainContext)
  const {onChange, formData: {credits}} = mainContext;

  useEffect(() => {
    ReactGA.pageview(window.location.pathname); 
  }, [])

  const moveForward = () => {
    let url = ''
    if (credits === "" || credits === null || parseInt(credits) < 0 || credits === 0) {
      setErrorMsg("Please enter number of credits completed");
      setSeeError(true);
      console.log("wrong");
      return;
    }
    if (parseInt(credits) >= 220 ) {
      url = '/results/'
    } else {
      url = '/survey/2/'
    }
    push(url)
    
  };

  const preventSubmit = (e) => {
    e.key === "Enter" && e.preventDefault();
  };
  return (
    <section id="modal-2">
      <div className="container">
        <h6 style={{ visibility: "hidden" }}>
          How many high school credits have you earned so far?
        </h6>
        <h2>How many high school credits have you earned so far?</h2>
        <div className="form">
          <input
            type="number"
            name="credits"
            value={credits}
            placeholder={24}
            onChange={(e) => onChange(e)}
            onKeyPress={preventSubmit}
          />
          {seeError && <p className="errorMsg">{errorMsg}</p>}
        </div>
        <Buttons advance={moveForward} goBack={() => {push('/')}} />
      </div>
    </section>
  );
};

export default withRouter(Modal2);
